import React, { useRef } from "react";
import { Formik } from "formik";
import Form from "./components/Form";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import Spin from "../../common/Spin";
import { API, fileUpload } from "../../../config";
import { toast } from "react-toastify";
import { AddAdminUserSchema } from "../../common/Validation";
import { useAdminRoleList } from "./components/UsersHelper";

const AddUsers = ({ toggleUsersModal, showUsers }) => {
  const [loading, setLoading] = useState(false);
  const [usersData, setUsersData] = useState();
  const formValues = useRef();
  let existingValues = [];
  let overwrittenFields = [];
  
  const { roleLoading, roleList = [] } = useAdminRoleList();
  const roleListing = roleList?.map((item) => {
    const name = item?.name;
    const id = item?.id;
    const items = { name, id };
    const { name: label, id: value, ...rest } = items;
    return { label, value, ...rest };
  });
  const role = roleListing?.find((item) => item?.value === usersData?.role_id);

  const handleFormSubmit = async (value) => {
    value.role_id = value?.role_id?.value ? value?.role_id?.value : "";
    value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";

    const formData = new FormData();
    formData.append("first_name", value?.first_name ? value?.first_name : "");
    formData.append("last_name", value?.last_name ? value?.last_name : "");
    formData.append("email", value?.email ? value?.email : "");
    formData.append("role_id", value?.role_id ? value?.role_id : "");
    formData.append("phone", value?.phone ? value?.phone : "");

    try {
      setLoading(true);
      const { data } = await fileUpload(`${API.GET_ADMIN_USER_LIST}`, formData);
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        toggleUsersModal();
      }
      return data?.data;
    } catch (error) {
      setUsersData(value);
      setLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Modal
        // size="lg"
        show={showUsers}
        onHide={toggleUsersModal}
        dialogClassName="modal-50w larg-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          New User
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              first_name: usersData?.first_name ? usersData?.first_name : "",
              last_name: usersData?.last_name ? usersData?.last_name : "",
              email: usersData?.email ? usersData?.email : "",
              role_id: role,
              phone: usersData?.phone ? usersData?.phone : "",
            }}
            enableReinitialize
            innerRef={formValues}
            onSubmit={handleFormSubmit}
            validateOnBlur={true}
            validateOnChange={true}
            validationSchema={AddAdminUserSchema}
          >
            {({
              values,
              setErrors,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <>
                  {loading && <Spin />}
                  <Form
                    values={values}
                    errors={errors}
                    setErrors={setErrors}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    formValues={formValues}
                    overwrittenFields={overwrittenFields}
                    existingValues={existingValues}
                    toggleUsersModal={toggleUsersModal}
                    roleLoading={roleLoading}
                    roleListing={roleListing}
                  />
                </>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddUsers;
